<template>
  <section>
    <v-container id="container">
    <v-row justify="center" id="nosotros">
      <v-col cols="12" md="6" align-self="center" class="mt-15">
        <v-img contain height="500" src="@/assets/vect/nosotros.svg"> </v-img>
      </v-col>
      <v-col cols="12" md="6">
        <v-container class="fill-height">
          <v-row justify="center" class="mb-5 my-md-15">
            <v-col cols="11" md="8" class="py-0">
              <h2 class="font-weight-bold mb-4 primary--text">
                {{ $t("nosotros.titulo") }}
              </h2>
            </v-col>
            <v-col cols="11" md="8" class="py-0">
              <div>
                {{ $t("nosotros.texto") }}
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "Toi",
};
</script>

<style scoped>
#nosotros {
  min-height: 100vh;
}
</style>
